
<template>
  <div>
    <md-toolbar>
        <h3 class="md-title">BhSystem</h3>
        <md-button to="/adm/dashboard">Dashboard</md-button>
        <md-button to="/adm/empresa">Empresas</md-button>
        <md-button to="/login">Sair</md-button>        
    </md-toolbar>
  </div>
</template>

<script>
export default {};
</script>